var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lc"},[_c('div',{staticClass:"lt-left"}),_c('div',{ref:"cmain1",staticClass:"cmain",style:({ width: '480px', height: '320px' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }